<div #scrollContainer class="cards content" fxLayout="row" fxLayoutAlign="start start">
    <div *ngIf="!dataCards.length" class="empty">{{ 'generic.nothing_to_display' | translate }}</div>
    <div *ngFor="let dataCard of dataCards" class="p-16" fxFlex="auto" fxFlex.gt-xs="50" fxFlex.gt-lg="33" >
        <app-card [dataCard]="dataCard" [ngClass]="getCardLayout()" fxFlex></app-card>
    </div>
</div>
<mat-paginator [length]="countEntities" [pageIndex]="pageIndex" [pageSizeOptions]="pageRangeOptions"
               (page)="onPaginateChange($event)">
</mat-paginator>
